// services/userService.js
import apiClient from './apiClient';
import API_ENDPOINTS from '../config/apiEndpoints';

class UserService {
    async registerUser(userData) {
        console.log("userService: Registering new user...");
        try {
            // Djoser attend username, email, password
            const response = await apiClient.post(API_ENDPOINTS.AUTH.REGISTER, userData);
            console.log("userService: User registered successfully.", response.data);
            return response.data;
        } catch (error) {
            console.error('userService: Error during user registration:', error.response ? error.response.data : error.message);
            // Propage l'erreur avec les détails de la réponse pour que le composant puisse afficher des messages spécifiques
            throw error.response ? error.response.data : new Error('An unexpected error occurred');
        }
    }

    async getUserProfile() {
        console.log("userService: Fetching user profile...");
        try {
            const response = await apiClient.get(API_ENDPOINTS.AUTH.USER_PROFILE);
            console.log("userService: Profile data fetched successfully.", response.data);
            return response.data;
        } catch (error) {
            console.error('userService: Error fetching user profile:', error);
            // L'intercepteur d'apiClient devrait déjà gérer les erreurs 401
            // On propage l'erreur pour que le composant puisse réagir (ex: afficher un message)
            throw error;
        }
    }

    async updateUserProfile(userData) {
        console.log("userService: Updating user profile...");
        try {
            // Djoser utilise PUT pour une mise à jour complète. Pour des mises à jour partielles, on utiliserait PATCH.
            const response = await apiClient.put(API_ENDPOINTS.AUTH.USER_PROFILE, userData);
            console.log("userService: Profile data updated successfully.", response.data);
            return response.data;
        } catch (error) {
            console.error('userService: Error updating user profile:', error);
            throw error;
        }
    }
}

const userServiceInstance = new UserService();
export default userServiceInstance;
